var _rect, _rect2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F2F2F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.75,
    y: 7.75,
    width: 10.5,
    height: 19.5,
    rx: 2.25,
    stroke: "#141233",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 17.9377C19.75 18.0367 19.6969 18.1181 19.6332 18.1818L17.0646 20.9522C16.8947 21.1326 16.8027 21.1574 16.7108 21.1574C16.6152 21.1574 16.5268 21.1361 16.3534 20.9522L13.7847 18.1818C13.7246 18.1181 13.668 18.0367 13.668 17.9377C13.668 17.7961 13.7777 17.7254 13.9086 17.7254H15.4759V17.5626C15.4759 15.4433 16.6435 13.9785 19.5094 13.9785C19.6545 13.9785 19.75 14.067 19.75 14.1837C19.75 14.2899 19.6934 14.35 19.5554 14.4102C18.4374 14.8772 17.9809 15.8714 17.9809 17.5626V17.7254H19.5094C19.6439 17.7254 19.75 17.7961 19.75 17.9377Z",
    fill: "#141233"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8H19V9C19 9.55228 18.5523 10 18 10H16C15.4477 10 15 9.55228 15 9V8Z",
    fill: "#141233"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.702d0393.svg";
export { ForwardRef as ReactComponent };